enum LeinPositionEnum {
  First = 'First',
  Second = 'Second',
  Third = 'Third',
}

export default LeinPositionEnum;
